import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center min-width-0" }
const _hoisted_2 = {
  key: 1,
  class: "icon"
}
const _hoisted_3 = { class: "flex-fill text-truncate pl-2" }

import CoreUiOperatorAvatar from "~/core-ui/vue/chat/CoreUiOperatorAvatar.vue";
import getOperatorDisplayName from "../../../../../../ts/service/operators/getOperatorDisplayName";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "OperatorSelectTag"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    operator: {},
    icon: {},
    descr: {},
    closable: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit;


return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createBlock(_component_el_tag, {
    type: "info",
    class: "h-auto overflow-visible tag custom",
    closable: __props.closable,
    style: {"padding-top":"1px","padding-left":"1px","padding-bottom":"1px"},
    onClose: _cache[0] || (_cache[0] = ($event: any) => (_unref(emits)('close')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (__props.operator)
          ? (_openBlock(), _createBlock(CoreUiOperatorAvatar, {
              key: 0,
              operator: __props.operator,
              size: "2em"
            }, null, 8, ["operator"]))
          : _createCommentVNode("", true),
        (__props.icon)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
              _createVNode(FontAwesomeIcon, { icon: __props.icon }, null, 8, ["icon"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, _toDisplayString(__props.operator ? _unref(getOperatorDisplayName)(__props.operator) : __props.descr), 1)
      ])
    ]),
    _: 1
  }, 8, ["closable"]))
}
}

})